// React/finance-app/src/features/tt-insights/tabs/TopBuyersTab.jsx
import React from 'react';
import { money } from '../utils';
import ExportButton from '../ExportButton';

const TopBuyersTab = ({
  loading,
  fetchTopBuyers,
  topCurUsers,
  topPrevUsers,
  topCurPeriod,
  topPrevPeriod,
  topMeta,
  topLimit,
  setTopLimit,
}) => (
  <div className="card">
    <div className="card-header d-flex flex-wrap gap-2 justify-content-between align-items-center">
      <span>Top Buyers — All Users (Current & Previous Month)</span>
      <div className="d-flex gap-2 align-items-center">
        <label className="me-1 small">Show first</label>
        <select
          className="form-select form-select-sm"
          style={{ width: 110 }}
          value={topLimit}
          onChange={(e) => setTopLimit(Number(e.target.value))}
        >
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={500}>500</option>
          <option value={999999}>All</option>
        </select>
        <button className="btn btn-primary btn-sm" onClick={fetchTopBuyers} disabled={loading}>
          {loading ? 'Loading…' : 'Refresh'}
        </button>
        <ExportButton
          disabled={
            loading || ((topCurUsers?.length ?? 0) + (topPrevUsers?.length ?? 0) === 0)
          }
          filenameBase={`top-buyers_${topCurPeriod || 'current'}_${topPrevPeriod || 'previous'}`}
          sheetName="Top Buyers"
          columns={[
            { key: "rank", header: "#" },
            { key: "user_code", header: "User Code" },
            { key: "rebate", header: "Rebate" },
            { key: "__period", header: "Period" },
          ]}
          rows={[
            ...(topCurUsers ?? [])
              .slice(0, topLimit)
              .map((r, i) => ({ ...r, rank: i + 1, __period: topCurPeriod || 'Current' })),
            ...(topPrevUsers ?? [])
              .slice(0, topLimit)
              .map((r, i) => ({ ...r, rank: i + 1, __period: topPrevPeriod || 'Previous' })),
          ]}
        />
      </div>
    </div>
    <div className="card-body">
      {/* Current Month */}
      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0">Current Month {topCurPeriod ? `(${topCurPeriod})` : ''}</h6>
          {topMeta && (
            <div className="text-muted small">
              Users: {topMeta.current_month_users ?? '—'} · Total Rebate: {money(topMeta.current_month_total)}
            </div>
          )}
        </div>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>User Code</th>
                <th>Rebate</th>
              </tr>
            </thead>
            <tbody>
              {(topCurUsers ?? []).slice(0, topLimit).map((row, idx) => (
                <tr key={`cur-${idx}`}>
                  <td>{idx + 1}</td>
                  <td>{row.user_code}</td>
                  <td title={String(row.rebate)}>{money(row.rebate)}</td>
                </tr>
              ))}
              {(topCurUsers ?? []).length === 0 && (
                <tr><td colSpan="3" className="text-center text-muted">No data</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Previous Month */}
      <div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0">Previous Month {topPrevPeriod ? `(${topPrevPeriod})` : ''}</h6>
          {topMeta && (
            <div className="text-muted small">
              Users: {topMeta.previous_month_users ?? '—'} · Total Rebate: {money(topMeta.previous_month_total)}
            </div>
          )}
        </div>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>User Code</th>
                <th>Rebate</th>
              </tr>
            </thead>
            <tbody>
              {(topPrevUsers ?? []).slice(0, topLimit).map((row, idx) => (
                <tr key={`prev-${idx}`}>
                  <td>{idx + 1}</td>
                  <td>{row.user_code}</td>
                  <td title={String(row.rebate)}>{money(row.rebate)}</td>
                </tr>
              ))}
              {(topPrevUsers ?? []).length === 0 && (
                <tr><td colSpan="3" className="text-center text-muted">No data</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default TopBuyersTab;
